// import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
// import {
//   Store,
//   ShoppingBag,
//   DollarSign,
//   Package,
//   LayoutDashboard,
//   Shield,
// } from "lucide-react";
// import { GlobalContext } from "../../Context/GlobalContext";
// import { useNavigate } from "react-router-dom";

// const getAdminIdFromSession = () => {
//   try {
//     const stored = sessionStorage.getItem("userData");

//     if (!stored) {
//       return null;
//     }
//     const userData = JSON.parse(stored);
//     const adminId = userData?.adminMeta?.adminId;
//     return adminId ? String(adminId) : null;
//   } catch (error) {
//     console.error("Error parsing userData from sessionStorage:", error);
//     return null;
//   }
// };

// const iconMap = {
//   Dashboard: LayoutDashboard,
//   Outlets: Store,
//   "Restaurant Reports": ShoppingBag,
//   Products: Package,
//   "Super Admin": Shield,
//   Sales: DollarSign,
// };

// export default function Navbar() {
//   const TEXT = "#101828";
//   const TEXT_MUTED = "#667085";

//   const navigate = useNavigate();
//   const { currentAdmin } = useContext(GlobalContext);
//   const { api } = useContext(GlobalContext);
//   const [menuItems, setMenuItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isAuthorized, setIsAuthorized] = useState(false);

//   const [searchInput, setSearchInput] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isParentSearch, setIsParentSearch] = useState(false);
//   const searchRef = useRef(null);

//   const [error, setError] = useState(null);
//   const fetchCalledRef = useRef(false);

//   const retryTimeoutRef = useRef(null);
//   const controllerRef = useRef(new AbortController());

//   const onAuthorizationChange = (isAuth) => {
//     console.log("Authorization changed to:", isAuth);
//   };

//   useEffect(() => {
//     if (fetchCalledRef.current) {
//       return;
//     }
//     fetchCalledRef.current = true;

//     const controller = new AbortController();

//     const fetchMenuAccess = async () => {
//       try {
//         setLoading(true);
//         if (onAuthorizationChange) {
//           onAuthorizationChange(null);
//         }

//         let adminId = getAdminIdFromSession();

//         if (!adminId) {
//           retryTimeoutRef.current = setTimeout(() => {
//             if (!controller.signal.aborted) {
//               const retryAdminId = getAdminIdFromSession();
//               if (retryAdminId) {
//                 fetchCalledRef.current = false;
//                 fetchMenuAccess();
//               } else {
//                 setError("unauthorized");
//                 setMenuItems([]);
//                 setIsAuthorized(false);
//                 setLoading(false);
//                 if (onAuthorizationChange) {
//                   onAuthorizationChange(false);
//                 }
//               }
//             }
//           }, 1000);
//           return;
//         }

//         const payload = { adminId };

//         const response = await api.post("Admin/v1.0/getUserAccess", payload);

//         if (
//           response.data.responseCode === "00" &&
//           response.data.response?.length > 0
//         ) {
//           const transformedMenu = response.data.response.map((item) => ({
//             name: item.menu_title,
//             icon: iconMap[item.menu_title] || LayoutDashboard,
//             path: item.submenus.length === 0 ? item.menu_url : null,
//             subItems:
//               item.submenus.length > 0
//                 ? item.submenus.map((sub) => ({
//                     name: sub.submenu_title,
//                     path: sub.submenu_url,
//                   }))
//                 : null,
//           }));

//           setMenuItems(transformedMenu);
//           setIsAuthorized(true);
//           setError(null);
//           if (onAuthorizationChange) {
//             onAuthorizationChange(true);
//           }
//         } else {
//           setMenuItems([]);
//           setIsAuthorized(false);
//           setError("unauthorized");
//           if (onAuthorizationChange) {
//             onAuthorizationChange(false);
//           }
//         }
//       } catch (error) {
//         if (error.name !== "AbortError") {
//           console.error("Error fetching menu access:", error);
//           setMenuItems([]);
//           setIsAuthorized(false);
//           setError("unauthorized");
//           if (onAuthorizationChange) {
//             onAuthorizationChange(false);
//           }
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMenuAccess();

//     return () => {
//       controller.abort();
//       if (retryTimeoutRef.current) {
//         clearTimeout(retryTimeoutRef.current);
//       }
//     };
//   }, [api, onAuthorizationChange]);

//   const searchableRoutes = useMemo(() => {
//     const routes = [];

//     if (!isAuthorized || menuItems.length === 0) {
//       return [];
//     }

//     menuItems.forEach((item) => {
//       if (item.path) {
//         routes.push({
//           name: item.name.toLowerCase(),
//           route: item.path,
//         });
//       }

//       if (item.subItems && item.subItems.length > 0) {
//         item.subItems.forEach((subItem) => {
//           routes.push({
//             name: subItem.name.toLowerCase(),
//             route: subItem.path,
//           });
//         });
//       }
//     });

//     return routes;
//   }, [isAuthorized, menuItems]);

//   const { name, userType } = useMemo(() => {
//     try {
//       const raw = sessionStorage.getItem("userData");
//       const ss = raw ? JSON.parse(raw) : null;
//       return {
//         name: currentAdmin?.name || ss?.adminMeta?.adminName || "Admin",
//         userType:
//           currentAdmin?.userType ||
//           ss?.userType ||
//           ss?.adminMeta?.userType ||
//           "Admin",
//       };
//     } catch {
//       return { name: currentAdmin?.name || "Admin", userType: "Admin" };
//     }
//   }, [currentAdmin]);

//   function roleColors(userType = "") {
//     const r = String(userType).toLowerCase();
//     if (r.includes("super"))
//       return { bg: "#FEE2E2", text: "#B91C1C", ring: "#FCA5A5" }; // Super Admin
//     if (r.includes("manager"))
//       return { bg: "#DBEAFE", text: "#1E40AF", ring: "#93C5FD" }; // Manager
//     if (r.includes("admin"))
//       return { bg: "#DCFCE7", text: "#1E3A8A", ring: "#93C5FD" }; // Admin
//     return { bg: "#F3F4F6", text: "#374151", ring: "#E5E7EB" }; // Default
//   }

//   const rc = roleColors(userType);

//   const [now, setNow] = useState(() => new Date());
//   useEffect(() => {
//     const t = setInterval(() => setNow(new Date()), 1000);
//     return () => clearInterval(t);
//   }, []);

//   const handleResultClick = (routePath) => {
//     navigate(routePath);
//     setSearchInput("");
//     setSearchResults([]);
//     setIsParentSearch(false);
//   };

//   const handleSearch = (event) => {
//     const input = event.target.value;
//     setSearchInput(input);
//     const query = input.trim().toLowerCase();

//     if (query === "") {
//       setSearchResults([]);
//       setIsParentSearch(false);
//       return;
//     }

//     const exactMatchRoute = searchableRoutes.find(
//       (item) => item.name === query
//     );

//     const matchingParent = menuItems.find(
//       (item) => item.name.toLowerCase() === query && item.subItems?.length > 0
//     );

//     if (matchingParent) {
//       setSearchResults(matchingParent.subItems);
//       setIsParentSearch(true);
//     } else if (exactMatchRoute) {
//       if (!isParentSearch) {
//         navigate(exactMatchRoute.route);
//         setSearchInput("");
//       }
//       setSearchResults([]);
//       setIsParentSearch(false);
//     } else {
//       const partialMatches = searchableRoutes.filter((item) =>
//         item.name.includes(query)
//       );
//       setSearchResults(partialMatches);
//       setIsParentSearch(false);
//     }
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setSearchResults([]);
//         setSearchInput("");
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchRef]);

//   const dateStr = now.toLocaleDateString(undefined, {
//     weekday: "short",
//     year: "numeric",
//     month: "short",
//     day: "2-digit",
//   });
//   const timeStr = now.toLocaleTimeString(undefined, {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//   });

//   const initials = useMemo(() => {
//     const parts = String(name).trim().split(/\s+/);
//     return (parts[0]?.[0] || "") + (parts[1]?.[0] || "");
//   }, [name]);

//   const quick = [
//     {
//       title: "Outlets",
//       to: "/outlets",
//       Icon: Store,
//       color: "text-blue-600",
//       bg: "bg-blue-100 hover:bg-blue-400",
//     },
//     {
//       title: "Reports",
//       to: "/business-reports",
//       Icon: ShoppingBag,
//       color: "text-green-600",
//       bg: "bg-green-100 hover:bg-green-400",
//     },
//     {
//       title: "Sales",
//       to: "/all-sales-person",
//       Icon: DollarSign,
//       color: "text-yellow-600",
//       bg: "bg-yellow-100 hover:bg-yellow-400",
//     },
//     {
//       title: "Products",
//       to: "/dashboard",
//       Icon: Package,
//       color: "text-purple-600",
//       bg: "bg-purple-100 hover:bg-purple-400",
//     },
//   ];

//   return (
//     <header className="flex items-center justify-between bg-white dark:bg-gray-800 shadow h-16 border-b px-4 relative">
//       {/* Left */}
//       <div className="flex-1 max-w-xs relative">
//         <div ref={searchRef}>
//           <input
//             type="text"
//             placeholder={
//               loading
//                 ? "Loading menu..."
//                 : isAuthorized
//                 ? "Search Route..."
//                 : "Unauthorized"
//             }
//             value={searchInput}
//             onChange={handleSearch}
//             disabled={!isAuthorized || loading}
//             className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white disabled:bg-gray-100 disabled:cursor-not-allowed"
//           />

//           {searchResults.length > 0 && (
//             <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
//               <ul className="py-1">
//                 {searchResults.map((result, index) => (
//                   <li
//                     key={index}
//                     onClick={() =>
//                       handleResultClick(result.route || result.path)
//                     }
//                     className="px-3 py-2 text-sm text-gray-800 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
//                   >
//                     {result.name}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Center */}
//       <div className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center text-center">
//         <span className="text-xs" style={{ color: TEXT_MUTED }}>
//           {dateStr}
//         </span>
//         <span className="text-sm font-semibold" style={{ color: TEXT }}>
//           {timeStr}
//         </span>
//       </div>

//       {/* Right */}
//       <div className="flex items-center gap-4">
//         {quick.map(({ title, Icon, to, color, bg }) => (
//           <a
//             key={title}
//             href={to}
//             title={title}
//             className={`group p-2 rounded-md border transition-colors duration-200 flex items-center justify-center ${bg}`}
//           >
//             <Icon
//               className={`${color} group-hover:text-white transition-colors duration-200`}
//               size={20}
//             />
//           </a>
//         ))}

//         {/* Profile Info */}
//         <div className="flex items-center gap-3">
//           <div className="text-right leading-tight">
//             <div
//               className="text-sm font-semibold truncate"
//               style={{ color: TEXT }}
//             >
//               {name}
//             </div>
//             <div className="text-xs truncate" style={{ color: rc.text }}>
//               {userType}
//             </div>
//           </div>
//           <div
//             className="h-9 w-9 rounded-full flex items-center justify-center text-xs font-semibold"
//             style={{
//               backgroundColor: "#FFFFFF",
//               color: rc.text,
//               border: `2px solid ${rc.ring}`,
//               boxShadow: "0 1px 0 rgba(16,24,40,0.04)",
//             }}
//             title={userType}
//           >
//             {initials || "AD"}
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }

import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import {
  Store,
  ShoppingBag,
  DollarSign,
  Package,
  LayoutDashboard,
  Shield,
  Wifi,
  WifiOff,
} from "lucide-react";
import { GlobalContext } from "../../Context/GlobalContext";
import { useNavigate } from "react-router-dom";

const BRAND = "#2563EB";

const getAdminIdFromSession = () => {
  try {
    const stored = sessionStorage.getItem("userData");
    if (!stored) return null;

    const userData = JSON.parse(stored);
    const adminId = userData?.adminMeta?.adminId;
    return adminId ? String(adminId) : null;
  } catch (error) {
    console.error("Error parsing userData from sessionStorage:", error);
    return null;
  }
};

const iconMap = {
  Dashboard: LayoutDashboard,
  Outlets: Store,
  "Restaurant Reports": ShoppingBag,
  Products: Package,
  "Super Admin": Shield,
  Sales: DollarSign,
};

// Simple bandwidth measurement as fallback when navigator.connection is unavailable
async function measureFetch() {
  const url = `/logo192.png?cb=${Date.now()}`;
  const started = performance.now();
  try {
    const res = await fetch(url, { cache: "no-store" });
    const buf = await res.arrayBuffer();
    const ended = performance.now();
    const bytes = buf.byteLength || 0;
    const seconds = Math.max((ended - started) / 1000, 0.001);
    const mbps = (bytes * 8) / seconds / (1024 * 1024);
    return { mbps };
  } catch {
    return null;
  }
}

// Custom hook to track online status & approx speed
function useNetworkStatus({ intervalMs = 20000 } = {}) {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);
  const [speedMbps, setSpeedMbps] = useState(null);
  const [label, setLabel] = useState("");

  useEffect(() => {
    const readNavigatorConnection = () => {
      const c =
        navigator.connection ||
        navigator.webkitConnection ||
        navigator.mozConnection;
      if (!c) return null;
      const downlink = typeof c.downlink === "number" ? c.downlink : null; // Mbps
      const eff = c.effectiveType || "";
      const rtt = typeof c.rtt === "number" ? c.rtt : null;
      return { downlink, eff, rtt };
    };

    const update = async () => {
      const online = navigator.onLine;
      setIsOnline(online);

      if (!online) {
        setSpeedMbps(null);
        setLabel("offline");
        return;
      }

      const conn = readNavigatorConnection();
      if (conn?.downlink) {
        setSpeedMbps(conn.downlink);
        setLabel(
          conn.eff
            ? `${conn.eff}${conn.rtt ? ` · ${conn.rtt}ms` : ""}`
            : "online"
        );
        return;
      }

      const result = await measureFetch();
      if (result?.mbps != null) {
        setSpeedMbps(result.mbps);
        setLabel("online");
      } else {
        setSpeedMbps(null);
        setLabel("online");
      }
    };

    const handleOnline = () => update();
    const handleOffline = () => update();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    update();
    const intervalId = setInterval(update, intervalMs);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(intervalId);
    };
  }, [intervalMs]);

  return { isOnline, speedMbps, label };
}

function roleColors(userType = "") {
  const r = String(userType).toLowerCase();
  if (r.includes("super"))
    return { bg: "#FEE2E2", text: "#B91C1C", ring: "#FCA5A5" }; // Super Admin
  if (r.includes("manager"))
    return { bg: "#DBEAFE", text: "#1E40AF", ring: "#93C5FD" }; // Manager
  if (r.includes("admin"))
    return { bg: "#DCFCE7", text: "#1E3A8A", ring: "#93C5FD" }; // Admin
  return { bg: "#F3F4F6", text: "#374151", ring: "#E5E7EB" }; // Default
}

export default function Navbar() {
  const TEXT = "#101828";
  const TEXT_MUTED = "#667085";

  const navigate = useNavigate();
  const { currentAdmin, api } = useContext(GlobalContext);

  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isParentSearch, setIsParentSearch] = useState(false);
  const searchRef = useRef(null);

  const [error, setError] = useState(null);
  const fetchCalledRef = useRef(false);
  const retryTimeoutRef = useRef(null);

  const { isOnline, speedMbps } = useNetworkStatus();

  const onAuthorizationChange = (isAuth) => {
    console.log("Authorization changed to:", isAuth);
  };

  useEffect(() => {
    if (fetchCalledRef.current) return;
    fetchCalledRef.current = true;

    const controller = new AbortController();

    const fetchMenuAccess = async () => {
      try {
        setLoading(true);
        if (onAuthorizationChange) {
          onAuthorizationChange(null);
        }

        let adminId = getAdminIdFromSession();

        if (!adminId) {
          retryTimeoutRef.current = setTimeout(() => {
            if (!controller.signal.aborted) {
              const retryAdminId = getAdminIdFromSession();
              if (retryAdminId) {
                fetchCalledRef.current = false;
                fetchMenuAccess();
              } else {
                setError("unauthorized");
                setMenuItems([]);
                setIsAuthorized(false);
                setLoading(false);
                if (onAuthorizationChange) {
                  onAuthorizationChange(false);
                }
              }
            }
          }, 1000);
          return;
        }

        const payload = { adminId };
        const response = await api.post("Admin/v1.0/getUserAccess", payload);

        if (
          response.data.responseCode === "00" &&
          response.data.response?.length > 0
        ) {
          const transformedMenu = response.data.response.map((item) => ({
            name: item.menu_title,
            icon: iconMap[item.menu_title] || LayoutDashboard,
            path: item.submenus.length === 0 ? item.menu_url : null,
            subItems:
              item.submenus.length > 0
                ? item.submenus.map((sub) => ({
                    name: sub.submenu_title,
                    path: sub.submenu_url,
                  }))
                : null,
          }));

          setMenuItems(transformedMenu);
          setIsAuthorized(true);
          setError(null);
          if (onAuthorizationChange) {
            onAuthorizationChange(true);
          }
        } else {
          setMenuItems([]);
          setIsAuthorized(false);
          setError("unauthorized");
          if (onAuthorizationChange) {
            onAuthorizationChange(false);
          }
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching menu access:", error);
          setMenuItems([]);
          setIsAuthorized(false);
          setError("unauthorized");
          if (onAuthorizationChange) {
            onAuthorizationChange(false);
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMenuAccess();

    return () => {
      controller.abort();
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [api]);

  const searchableRoutes = useMemo(() => {
    const routes = [];

    if (!isAuthorized || menuItems.length === 0) return [];

    menuItems.forEach((item) => {
      if (item.path) {
        routes.push({
          name: item.name.toLowerCase(),
          route: item.path,
        });
      }

      if (item.subItems && item.subItems.length > 0) {
        item.subItems.forEach((subItem) => {
          routes.push({
            name: subItem.name.toLowerCase(),
            route: subItem.path,
          });
        });
      }
    });

    return routes;
  }, [isAuthorized, menuItems]);

  const { name, userType } = useMemo(() => {
    try {
      const raw = sessionStorage.getItem("userData");
      const ss = raw ? JSON.parse(raw) : null;
      return {
        name: currentAdmin?.name || ss?.adminMeta?.adminName || "Admin",
        userType:
          currentAdmin?.userType ||
          ss?.userType ||
          ss?.adminMeta?.userType ||
          "Admin",
      };
    } catch {
      return { name: currentAdmin?.name || "Admin", userType: "Admin" };
    }
  }, [currentAdmin]);

  const rc = roleColors(userType);

  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const handleResultClick = (routePath) => {
    navigate(routePath);
    setSearchInput("");
    setSearchResults([]);
    setIsParentSearch(false);
  };

  const handleSearch = (event) => {
    const input = event.target.value;
    setSearchInput(input);
    const query = input.trim().toLowerCase();

    if (query === "") {
      setSearchResults([]);
      setIsParentSearch(false);
      return;
    }

    const exactMatchRoute = searchableRoutes.find(
      (item) => item.name === query
    );

    const matchingParent = menuItems.find(
      (item) => item.name.toLowerCase() === query && item.subItems?.length > 0
    );

    if (matchingParent) {
      setSearchResults(matchingParent.subItems);
      setIsParentSearch(true);
    } else if (exactMatchRoute) {
      if (!isParentSearch) {
        navigate(exactMatchRoute.route);
        setSearchInput("");
      }
      setSearchResults([]);
      setIsParentSearch(false);
    } else {
      const partialMatches = searchableRoutes.filter((item) =>
        item.name.includes(query)
      );
      setSearchResults(partialMatches);
      setIsParentSearch(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchResults([]);
        setSearchInput("");
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dateStr = now.toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
  const timeStr = now.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const initials = useMemo(() => {
    const parts = String(name).trim().split(/\s+/);
    return (parts[0]?.[0] || "") + (parts[1]?.[0] || "");
  }, [name]);

  const quick = [
    {
      title: "Outlets",
      to: "/outlets",
      Icon: Store,
      color: "text-blue-600",
      bg: "bg-blue-100 hover:bg-blue-400",
    },
    {
      title: "Reports",
      to: "/business-reports",
      Icon: ShoppingBag,
      color: "text-green-600",
      bg: "bg-green-100 hover:bg-green-400",
    },
    {
      title: "Sales",
      to: "/all-sales-person",
      Icon: DollarSign,
      color: "text-yellow-600",
      bg: "bg-yellow-100 hover:bg-yellow-400",
    },
    {
      title: "Products",
      to: "/dashboard",
      Icon: Package,
      color: "text-purple-600",
      bg: "bg-purple-100 hover:bg-purple-400",
    },
  ];

  const statusColors = isOnline
    ? { textRight: "#15803D" } // green
    : { textRight: "#DC2626" }; // red

  return (
    <header className="flex items-center justify-between bg-white dark:bg-gray-800 shadow h-16 border-b px-4 relative">
      {/* Left - Search */}
      <div className="flex-1 max-w-xs relative">
        <div ref={searchRef}>
          <input
            type="text"
            placeholder={
              loading
                ? "Loading menu..."
                : isAuthorized
                ? "Search Route..."
                : "Unauthorized"
            }
            value={searchInput}
            onChange={handleSearch}
            disabled={!isAuthorized || loading}
            className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white disabled:bg-gray-100 disabled:cursor-not-allowed"
          />

          {searchResults.length > 0 && (
            <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
              <ul className="py-1">
                {searchResults.map((result, index) => (
                  <li
                    key={index}
                    onClick={() =>
                      handleResultClick(result.route || result.path)
                    }
                    className="px-3 py-2 text-sm text-gray-800 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                  >
                    {result.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Center - Date/Time + Network status */}
      <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-4 text-center border p-3 bg-sky-100 rounded border-blue-500">
        {/* Date */}
        <span className="text-sm font-medium" style={{ color: TEXT_MUTED }}>
          {now.toLocaleDateString(undefined, {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "2-digit",
          })}
        </span>

        {/* Time in 12-hour format */}
        <span className="text-sm font-semibold" style={{ color: TEXT }}>
          {now.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          })}
        </span>

        {/* Network Status */}
        <div className="flex items-center gap-1 text-xs font-medium">
          {isOnline ? (
            <>
              <Wifi size={16} style={{ color: BRAND }} />
              <span style={{ color: "#15803D" }}>
                Online
                {typeof speedMbps === "number"
                  ? ` · ${speedMbps.toFixed(1)} Mbps`
                  : ""}
              </span>
            </>
          ) : (
            <>
              <WifiOff size={16} style={{ color: "#DC2626" }} />
              <span style={{ color: "#DC2626" }}>Offline</span>
            </>
          )}
        </div>
      </div>

      {/* Right - Quick links + Profile */}
      <div className="flex items-center gap-4">
        {quick.map(({ title, Icon, to, color, bg }) => (
          <a
            key={title}
            href={to}
            title={title}
            className={`group p-2 rounded-md border transition-colors duration-200 flex items-center justify-center ${bg}`}
          >
            <Icon
              className={`${color} group-hover:text-white transition-colors duration-200`}
              size={20}
            />
          </a>
        ))}

        {/* Profile Info */}
        <div className="flex items-center gap-3">
          <div className="text-right leading-tight">
            <div
              className="text-sm font-semibold truncate"
              style={{ color: TEXT }}
            >
              {name}
            </div>
            <div className="text-xs truncate" style={{ color: rc.text }}>
              {userType}
            </div>
          </div>
          <div
            className="h-9 w-9 rounded-full flex items-center justify-center text-xs font-semibold"
            style={{
              backgroundColor: "#FFFFFF",
              color: rc.text,
              border: `2px solid ${rc.ring}`,
              boxShadow: "0 1px 0 rgba(16,24,40,0.04)",
            }}
            title={userType}
          >
            {initials || "AD"}
          </div>
        </div>
      </div>
    </header>
  );
}
